<h2 mat-dialog-title>Assign Team Leaders</h2>

<mat-dialog-content>
  <p class="dialog-copy">
    This will assign Team Leaders for all games matching the current schedule
    filters.
  </p>

  <div class="summary-panel">
    <div class="summary-label">Games affected</div>
    <div class="summary-count">{{ data.gameCount }}</div>
  </div>

  <div class="dialog-section">
    <div class="section-title">Active filters</div>

    <div class="section-empty" *ngIf="data.filterItems.length === 0">
      No active filters. Team Leaders will be assigned across all schedule
      games.
    </div>

    <div class="filter-grid" *ngIf="data.filterItems.length > 0">
      <ng-container *ngFor="let item of data.filterItems">
        <div class="filter-label">{{ item.label }}</div>
        <div class="filter-value">{{ item.value }}</div>
      </ng-container>
    </div>
  </div>

  <div class="dialog-section">
    <div class="section-title">Coverage plan</div>
    <div class="coverage-row" *ngFor="let item of data.coveragePlan">
      <span class="coverage-league">{{ item.leagueShortName }}</span>
      <span class="coverage-leader">{{ item.teamLeaderName }}</span>
      <span class="coverage-value">{{ item.coverage }}%</span>
    </div>
  </div>

  <div class="warning-message" *ngIf="countExceedsLimit">
    Team Leaders can be assigned to up to
    {{ data.autoAssignGameLimit }} games at once. Narrow the filters and try
    again.
  </div>

  <div class="validation-errors" *ngIf="data.validationErrors.length > 0">
    <div *ngFor="let error of data.validationErrors">{{ error }}</div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close(false)">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    class="run-assignment"
    type="button"
    [disabled]="!canConfirm"
    (click)="close(true)"
  >
    Run
  </button>
</mat-dialog-actions>
